import { render, staticRenderFns } from "./ButtonWithQrCode.vue?vue&type=template&id=35ae7f60&scoped=true&"
import script from "./ButtonWithQrCode.vue?vue&type=script&lang=js&"
export * from "./ButtonWithQrCode.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithQrCode.vue?vue&type=style&index=0&id=35ae7f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae7f60",
  null
  
)

export default component.exports